<template>
  <v-dialog
    :max-width="width"
    :persistent="persistent"
    @click:outside="closeDialog"
    v-model="showDialog"
    @keydown.esc="closeDialog"
    :fullscreen="fullscreen"
    :transition="transition"
    :class="fullscreen ? 'fullscreen' : ''"
  >
    <v-card class="ma-0">
      <v-card-title
        class="d-flex justify-space-between white--text align-center"
        :class="color"
      >
        <slot name="header">
          {{ $t("titles.infoMessage") }}
        </slot>

        <v-btn icon :title="$t('buttons.close')" @click="closeDialog">
          <v-icon color="white" icon="mdi-close" />
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="py-4 dialog-body">
        <slot name="body">
          {{ $t("titles.infoMessage") }}
        </slot>
      </v-card-text>
      <v-divider />

      <v-card-actions class="d-flex justify-end">
        <slot name="actions">
          <v-btn color="primary" variant="flat" @click="closeDialog">
            {{ $t("buttons.ok") }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DialogComponent',

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '600px',
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: ' dialog-transition',
    },
    color: {
      type: String,
      default: 'blue-grey',
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.modelValue;
      },
      set(val: boolean) {
        this.$emit('update:modelValue', val);
      },
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
      if (!this.preventClose) {
        this.$emit('update:modelValue', false);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
// .dialog-body {
//   max-height: 60vh;
//   overflow: auto;
// }
:deep(.v-dialog){
  overflow-x: hidden;
}
.v-btn{
  background: transparent;
}
.dialog-body{
  max-height: fit-content;
}

</style>
